export const FETCH_LINKS = 'FETCH_LINKS';

export const ADD_NEW_LINK = 'ADD_NEW_LINK';
export const VOTE_LINK = 'VOTE_LINK';
export const DELETE_LINK = 'DELETE_LINK';
export const SORT_LINKS = 'SORT_LINKS';
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE';


